import ListItem from '@mui/material/ListItem';
import { FC } from 'react';
import { IClientType, useDeleteClientTypeMutation } from 'src/redux/services/settings';
import { CustomTypography } from '../../custom/CustomTypography';
import { IconWithTooltip } from '../../shared/IconWithTooltip';
import styles from './EditClientTypes.module.css';

type ClientTypeProps = {
  type: IClientType;
  onClick: () => void;
};

export const ClientType: FC<ClientTypeProps> = ({ type, onClick }) => {
  const [deleteClientType] = useDeleteClientTypeMutation();

  const handleDelete = async () => {
    if (type) {
      try {
        await deleteClientType(type.id).unwrap();
      } catch (error) {
        console.error('Ошибка удаления типа приложения:', error);
      }
    }
  };

  return (
    <ListItem className={styles.item}>
      <div className={styles.content}>
        <CustomTypography>{type.name}</CustomTypography>
        <div>
          <IconWithTooltip iconType="edit" onClick={onClick} />
          <IconWithTooltip iconType="delete" onClick={handleDelete} />
        </div>
      </div>
    </ListItem>
  );
};
